import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import DrawingSearchPanel from "../DesignerSearchPanel";
import DrawingSnGrid from "../DesignerSnGrid";

interface Props {
  loadData?: any;
}

const TemplateRep1 = forwardRef(({ loadData }: Props, ref) => {
  const gridRef = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([{}]);

  useEffect(() => {
    if (!loadData) {
      setFormData(null);
      setFormControlData([]);
      setColumns([{}]);
    } else {
      setFormData(loadData.formData);
      setFormControlData(loadData.formControlData);
      setColumns(loadData.grid.grid1);
    }
  }, [loadData]);

  useImperativeHandle(ref, () => ({
    getSaveData,
  }));

  const getSaveData = () => {
    const searchformData = searchRef.current.getFormData();
    const searchControls = searchRef.current.getControls();
    const gridColumns = gridRef.current.getColumns();
    const rtn = {
      formData: searchformData,
      formControlData: searchControls,
      grid: { grid1: gridColumns },
    };
    return rtn;
  };

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <DrawingSearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></DrawingSearchPanel>
      </div>
      <div className="flex-1">
        <DrawingSnGrid
          ref={gridRef}
          seq={1}
          enableAddRow={true}
          columnConfig={columns}
          rowData={[]}
          title=""
        />
      </div>
    </div>
  );
});

export default TemplateRep1;
